import api from '@http/api';
import { IPerfil } from '@interfaces/UserComplete';

interface IInserirDoacao {
  perfil_id: string;
  estrategia_id: string;
  origem_doacao_id: string;
  valor_doacao: string;
  data_doacao: string;
  observacao: string;
  loteDoacaoId: string;
}

export interface IFormaContribuicao {
  id: string;
  descricao: string;
  data_cadastro: string;
  status_ativo: boolean;
}

export interface IEstrategias {
  id: string;
  nome: string;
  campanha_id: string;
  descricao: string;
}

export interface IResponseRequestPessoaByCPF {
  pessoa: {
    id: string;
    documento: string;
    nome: string;
    perfis: IPerfil[];
    tipos_perfis: string[];
  };
}

export interface IResponsePessoaByCPF {
  response?: {
    pessoa: {
      id: string;
      nome: string;
      documento: string;
      perfis: IPerfil[];
      tipos_perfis: string[];
    };
  };
  error: boolean;
}

export interface IResponse {
  response?: IPerfil[];
  error: boolean;
}

class Services {
  public async loadFormaContribuicao() {
    return await api
      .get<IFormaContribuicao[]>('/api/Doacao/GetOrigensDoacao')
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

  public async loadEstrategias() {
    return await api
      .get<IEstrategias[]>('/api/Estrategia/GetEstrategiasFiltradas')
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

  public async getPessoaByID(id: number): Promise<IResponsePessoaByCPF> {
    return await api
      .get(`api/Pessoa/GetPessoaById/${id}`)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
        };
      });
  }

  public async getPessoaByDocumento(
    documento: string,
  ): Promise<IResponsePessoaByCPF> {
    return await api
      .post<IResponseRequestPessoaByCPF>(`api/Pessoa/FindPessoaByCpf`, {
        documento,
      })
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
        };
      });
  }

  public async inserirDoacao({
    estrategia_id,
    origem_doacao_id,
    perfil_id,
    valor_doacao,
    data_doacao,
    observacao,
    loteDoacaoId,
  }: IInserirDoacao): Promise<{ error: boolean; doacaoId?: number }> {
    return await api
      .post(`api/Doacao/InserirDoacao`, {
        estrategia_id,
        origem_doacao_id,
        perfil_id,
        valor_doacao,
        data_doacao,
        observacao,
        loteDoacaoId,

      })
      .then(response => {
        const doacaoId = response.data?.id;
        console.log('ID da doação retornado pela API:', doacaoId);
        return {
          error: false,
          doacaoId,
        };
      })
      .catch(() => {
        return { error: true };
      });
  }

  public async gerarRecibo(doacaoId: number): Promise<{ error: boolean; response?: Blob }> {
    return await api
      .get(`/api/Doacao/GetReciboDoacao`, {
        params: { doacaoId },
        responseType: 'blob',
      })
      .then(response => ({
        error: false,
        response: response.data,
      }))
      .catch(() => ({ error: true }));
  }

  public async GetLotesAbertos() {
    return await api
      .get('/api/LoteDoacao/lotes-abertos-usuario')
      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }

}

export default Services;
